




















import { Component, Vue } from "vue-property-decorator";

import { Plant, Plants } from "@/types";
import { className } from "@/utilities";

import PlantGroup from "@/components/PlantGroup.vue";
import PlantSearch from "@/components/PlantSearch.vue";
import PlantBackground from "@/components/PlantBackground.vue";

@Component({
  components: {
    PlantGroup,
    PlantBackground,
    PlantSearch,
  },
})
export default class PlantTypeView extends Vue {
  get searchText() {
    return this.$route.params.searchText;
  }

  get plants() {
    return (this.$store.getters.searchPlants(this.searchText) as [
      number,
      Plant
    ][]).map(([number, plant]) => ({
      ...plant,
      number,
    }));
  }
}
